import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'posted', label: 'Posted' },
  { value: 'exported', label: 'Exported' },
  { value: 'confirmed', label: 'Confirmed' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'journal_number', label: 'Journal #' },
  { key: 'entry_date', label: 'Date' },
  { key: 'description', label: 'Description' },
  { key: 'total_debit', label: 'Total Debit', align: 'right', type: 'money' },
  { key: 'total_credit', label: 'Total Credit', align: 'right', type: 'money' },
  { key: 'status', label: 'Status' },
  { key: 'created_by', label: 'Created By' },
  { key: 'posted_by', label: 'Posted By' },
];

export function CorrectingJournalsReport() {
  return (
    <ReportView
      title="Correcting Journals Register"
      description="Every manual correcting journal entry, with debit/credit totals and posting status."
      endpoint="/reports/gl/correcting-journals"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      defaultSort="entry_date"
    />
  );
}
